import { render, staticRenderFns } from "./ApprovalProcess.vue?vue&type=template&id=50d618e2&scoped=true&"
import script from "./ApprovalProcess.vue?vue&type=script&lang=js&"
export * from "./ApprovalProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d618e2",
  null
  
)

export default component.exports